module.exports = __webpack_public_path__ + "static/fifth_user_image3-25018da040828c1b2e0f4220a09edbfd.jpg";